import { z } from 'zod';
import { isoDate } from './common.js';
import { VacancyStatus } from '../types/enums.js';
export const createVacancySchema = z.object({
    projectId: z.string().uuid(),
    role: z.string().min(1),
    startDate: isoDate,
    duration: z.string().min(1),
    requiredSkills: z.array(z.string()).default([]),
    statusFilter: z.array(z.string()).default([]),
    requesterId: z.string().uuid().nullable().optional(),
    notes: z.string().nullable().optional(),
});
export const updateVacancySchema = createVacancySchema.partial().extend({
    status: z.nativeEnum(VacancyStatus).optional(),
});
export const markFilledSchema = z.object({
    filledBy: z.string().uuid().nullable().optional(),
});
export const vacancyQuerySchema = z.object({
    status: z.nativeEnum(VacancyStatus).optional(),
    projectId: z.string().uuid().optional(),
    role: z.string().optional(),
});
//# sourceMappingURL=vacancy.js.map